<template>
  <div class="user_info_view">
    <div class="user_info_head">
      <div class="deco">
        <h2>출금 정보</h2>
        <p>현금 캐시백을 위한 사용자 정보와 지급 계좌 정보를 관리할 수 있습니다.</p>
        <div class="bt">
          <v-button @handleClick="handleClick()" text="사업자 처리 내역" class="btn09" iconClass="icon_list"></v-button>
        </div>
      </div>
    </div>
    <view-individual v-if="userInfo.businessType === 1"></view-individual>
    <view-business v-else></view-business>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VButton from '@/components/atoms/VButton';
import ViewIndividual from '@/components/templates/userInfo/view/ViewIndividual';
import ViewBusiness from '@/components/templates/userInfo/view/ViewBusiness';

export default {
  components: {
    VButton,
    ViewIndividual,
    ViewBusiness,
    // ViewError,
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  async created() {
    await this.getUserInfo();
  },
  methods: {
    ...mapActions('userInfo', ['getUserInfo', 'setModifyUserName']),
    handleClick() {
      this.$router.replace({ name: 'UserInfoHistory' });
    },
  },
  mounted() {
    // this.setModifyUserName({});
  },
};
</script>

<style></style>
